import { getRequest, patchRequest } from "../utils/axios";

export const organizationsService = {
  list: (onSuccess, onError) =>
    getRequest("/api/v1/organizations/", onSuccess, onError),
  get: (hash, onSuccess, onError) =>
    getRequest(`/api/v1/organizations/${hash}/`, onSuccess, onError),
  update: (hash, data, onSuccess, onError) =>
    patchRequest(`/api/v1/organizations/${hash}/`, data, onSuccess, onError),
};
